import React from "react";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import { HorizontalCardStyled } from "./styles";
 
interface AnalyticsCardProps {
  icon: string;
  label: string;
  value: number | string;
  variation?: number;
}

export const AnalyticsCard: React.FC<AnalyticsCardProps> = ({
  icon,
  label,
  value,
  variation,
}) => {
  const shouldShowVariation = typeof variation === "number" && variation > 0;

  return (
    <HorizontalCardStyled>
      <div className="left-container">
        <div className="icon-container">
          <img src={icon} alt={label} className="icon" />
          <span className="label">{label}</span>
        </div>
      </div>

      {shouldShowVariation ? (
        <div className="right-container">
          <span className="value">{value}</span>
          <TrendingUpOutlinedIcon sx={{ color: "#0F9D58" }} />
          <span
            className="trend-value"
            style={{ color: "#0F9D58" }}
          >
            {variation}%
          </span>
        </div>
      ) : (
        <span className="value">{value}</span>
      )}
    </HorizontalCardStyled>
  );
};
